import React from "react";
import { modalBoxStyle } from "../styles";
import {
  Button,
  Typography,
  Box,
  Modal,
  Grid,
  IconButton,
} from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { useNavigate } from "react-router-dom";

const OrderToParSuccessModal = ({ isOpen, closeModal, establishmentId }) => {
  const navigate = useNavigate();
  const handleNavigateToOrders = () => {
    navigate(`/spec/${establishmentId}/cart/review`);
  };

  return (
    <Modal
      open={isOpen}
      onClose={closeModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={modalBoxStyle}>
        <Grid
          container
          direction="column"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid
            container
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Grid item>
              <Typography variant="h2">Success!</Typography>
            </Grid>
            <Grid item>
              <IconButton onClick={closeModal}>
                <CloseOutlinedIcon />
              </IconButton>
            </Grid>
          </Grid>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              flexDirection: "column",
              width: "100%",
              marginTop: 4,
            }}
          >
            {" "}
            <Typography variant="body1">
              We have update your establishment&apos;s cart based on this
              count&apos;s par levels. Would you like to go to your cart now?
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "3rem",
              width: "100%",
            }}
          >
            <Button
              variant="outlined"
              onClick={closeModal}
              sx={{ width: "50%", marginRight: 1 }}
            >
              <Typography variant="largeButton">No, Stay</Typography>
            </Button>
            <Button
              variant="contained"
              sx={{
                width: "50%",
                height: "40px",
                marginLeft: 1,
              }}
              onClick={handleNavigateToOrders}
            >
              <Typography variant="largeButton">Yes</Typography>
            </Button>
          </Box>
        </Grid>
      </Box>
    </Modal>
  );
};

export default OrderToParSuccessModal;
